import { Component, Input, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { UserSelectors } from '@next/core-lib/user';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  standalone: false,
})
export class GeneralInfoComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  @Input() reportForLabel = 'reportFor';
  customer$ = this.store.pipe(select(UserSelectors.selectCustomer));
}
